import {
  Box,
  Button,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";

//  loading
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { useNavigate } from "react-router-dom";
import {
  useGetFavoriteApiQuery,
  usePatchFavoriteApiMutation,
} from "../../../../../Store/Slices/rtk";
import toast from "react-hot-toast";
export default function ProfileFavorites() {
  const navigate = useNavigate();
  const theme = useTheme();

  const { data, refetch, status, isLoading } = useGetFavoriteApiQuery(
    undefined,
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const [patchFavoriteApi, isloading] = usePatchFavoriteApiMutation();

  const handleDel = async (coder) => {
    const del = await patchFavoriteApi(coder);
    if (del?.data?.status != "ok") {
      return toast.error("مشکلی در حذف پیش آمد");
      refetch();
    }
    toast.success("با موفقیت حذف شد");
    refetch();
  };
  const items = data?.data?.data?.favorite?.map((item, index) => {
    return (
      <Stack
        direction={"row"}
        sx={{
          bgcolor: "white",
          py: ".3rem",
          color: theme.palette.warning.main,
          borderRadius: "6px",
          direction: "rtl",
          alignItems: "center",
          width: "100%",
          px: ".3rem",
        }}
      >
        <Stack
          direction={"row"}
          alignItems={"center"}
          gap={".5rem"}
          justifyContent={"start"}
          width={"45%"}
        >
          <Box sx={{ width: "45px", height: "45px" }}>
            <img style={{ width: "100%", height: "100%" }} src="" alt="" />
          </Box>
          <Typography
            sx={{ textAlign: "center", fontSize: { xs: ".8rem", md: "1rem" } }}
          >
            {item?.name}
          </Typography>
        </Stack>

        <Typography
          sx={{
            textAlign: "center",
            width: "25%",
            fontSize: { xs: ".8rem", md: "1rem" },
          }}
        >
          {item?.price}
        </Typography>
        <Stack
          direction={"row"}
          sx={{
            width: "30%",
            fontSize: { xs: ".7rem", sm: ".8rem", md: "1rem" },
            color: theme.palette.primary.main,
            fontWeight: "bold",
            justifyContent: "end",
          }}
        >
          <Button
            sx={{
              fontSize: ".8rem",
              padding: "0",
              margin: "0",
              width: "100%",
              justifyContent: "left",
            }}
            onClick={() => navigate(`/product-details/pid/vid`)}
          >
            محصول
          </Button>
          <IconButton onClick={() => handleDel(item?.code)} color="error">
            <DeleteForeverIcon />
          </IconButton>
        </Stack>
      </Stack>
    );
  });
  return (
    <Stack gap={"1.5rem"} mt={"1rem"}>
      {/* Header */}
      <Stack
        direction={"row"}
        sx={{
          borderRadius: "8px",
          py: "1rem",
          bgcolor: theme.palette.background.lightCream,

          justifyContent: "space-between",
          direction: "rtl",
          display : items?.length > 0 ? "flex" : 'none'
        }}
      >
        <Typography sx={{ pr: "3rem", width: "45%" }}>محصول</Typography>
        <Typography sx={{ textAlign: "center", width: "25%" }}>مبلغ</Typography>
        <Typography sx={{ pl: "1rem", textAlign: "left", width: "30%" }}>
          عملیات
        </Typography>
      </Stack>

      {/* Rows */}
      <Stack
        sx={{
          gap: ".7rem",
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f0f0f0",
            borderRadius: "8px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#1976d2",
            borderRadius: "8px",
            border: "2px solid #f0f0f0",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#115293",
          },

          scrollbarWidth: "thin",
          scrollbarColor: `${theme.palette.primary.main} ${theme.palette.secondary.main}`,
        }}
        direction={"column"}
      >
        {items?.length > 0 ? (
          items
        ) : (
          <Stack
            sx={{
              color: theme.palette.primary.main,
              justifyContent: "center",
              alignItems: "center",
              height: { xs: "450px", sm: "500px" },
              width: "100%",
              fontSize: "1.2rem",
            }}
          >
            هنوز محصولی اضافه نشده است
          </Stack>
        )}
      </Stack>
    </Stack>
  );
}
